<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :module_name="page.name"/>
    <v-row>
      <v-col>
        <base-table ref="base_table" :page="page" @edit="edit"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseTable from "../../components/commonComponents/BaseTable";
import BaseBreadcrumb from "../../components/commonComponents/BaseBreadcrumb";
export default {
  components: {
    BaseTable,
    BaseBreadcrumb,
  },
  data() {
    return {
      page: {
        title: this.$store.getters.translate("dossiers"),
        name: "dossiers",
        model: "dossier",
      },
    };
  },
  methods: {
    edit(item) {
      this.$router.push("/" + this.page.name + "/" + item.id);
    },
  },
};
</script>
